import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import {
  CreateFaq,
  DeleteFaq,
  UpdateFaq,
  getenterpriseswithtypes
} from "../../actions/machines";
import {
  CreateWorkFlowStep,
  UpdateWorkFlowStep,
  getAttachments
} from "../../actions/notification";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper/Paper";
import Typography from "@mui/material/Typography/Typography";
import { createArea } from "../../actions/objects";
import DeletePopUp from "../../components/DeletePopup";
import { canUserPerformAction } from "../../shared-functions/userrights";
import { Theme247 } from "../../styles/Theme247";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";
import NotificationAttachments, {
  persistAttachmentMetadataUpdates
} from "../NotificationDetailsPage/NotificationAttachments";

import axios, * as others from "axios";
import { getItem } from "../../utils/DataProtection";
var do_once = true;
export default connect(
  ({ enterprises, isAuthUser, machines, i18n, notification }) => ({
    enterprises,
    isAuthUser,
    machines,
    i18n,
    notification
  }),
  {
    getenterpriseswithtypes,
    createArea,
    getAttachments,
    CreateWorkFlowStep,
    UpdateWorkFlowStep,
    CreateFaq,
    UpdateFaq,
    DeleteFaq
  }
)(props => {
  const i18n = props.i18n;
  const [startDate, setStartDate] = useState();
  const [types, settypes] = useState({});
  const [selectedFile, setselectedFile] = useState("");
  const [url, seturl] = useState("");
  const [fileid, setfileid] = useState("");

  const [description, setdescription] = useState("");
  const [title_workflow, settitle_workflow] = useState("");

  const [machinepoolid, setmachinepoolid] = useState("");
  const [values, setValues] = React.useState({
    showPassword: false
  });
  const [equipmentid, setequipmentid] = useState("");
  const [inventoryid, setinventoryid] = useState("");
  const [constructionDate, setconstructionDate] = useState("");
  const [manufacturerserialnumber, setmanufacturerserialnumber] = useState("");
  const [memo, setmemo] = useState("");
  const [equipmenttypenodeid, setequipmenttypenodeid] = useState("");
  const [uploadurl, setuploadurl] = useState("");

  const [mimetype, setmimetype] = useState("");

  const [child_image, setchild_image] = useState("");
  const [equipmentpoolnodeid, setequipmentpoolnodeid] = useState("");

  const [navigate, setNavigate] = useState(false);
  let location = props.propLocation
    ? { state: props.propLocation }
    : useLocation();

  const getNotificationDetailsPath = () => {
    const notificationNodeId = location.state?.notification?.nodeid;
    const notificationType = location.state?.notification?.type;

    if (!notificationNodeId) return "/notification-details";

    return (
      "/notification-details?nodeid=" +
      encodeURIComponent(notificationNodeId) +
      (notificationType !== 6 ? "&tab=2" : "")
    );
  };

  useEffect(() => {
    if (location.state && location.state.from == "notification") {
      settitle_workflow(location.state && location.state.title);
      setdescription(location.state && location.state.description);
    } else if (location.state && location.state.from == "faq") {
      settitle_workflow(location.state && location.state.question);
      setdescription(location.state && location.state.answer);
    }
  }, []);

  const navigatee = useNavigate();

  useEffect(() => {
    if (navigate) {
      if (location.state.from === "faq") {
        navigatee(
          "/machine-overview?nodeid=" +
            encodeURIComponent(location.state.equipmentnodeid) +
            "&tab=-1"
        );
        setTimeout(() => {
          navigatee(
            "/machine-overview?nodeid=" +
              encodeURIComponent(location.state.equipmentnodeid) +
              "&tab=3"
          );
        }, 1000);
      } else {
        navigatee(
          location.state && location.state.from == "notification"
            ? getNotificationDetailsPath()
            : "/equipmenttype-overview?nodeid=" +
                encodeURIComponent(location?.state?.equipmentnodeid) +
                "&tab=2"
        );
      }
    }
  }, [navigate]);

  const [noti_loader, setnoti_loader] = useState(false);
  const submitForm = async e => {
    e.preventDefault();

    setnoti_loader(true);

    //attachments
    const attachmentObject = {
      HEADER: {
        LANGUAGE_VERSION: "1.0.0"
      },

      OBJECTS: []
    };
    let urlArray = []; // unknown # of urls (1 or more)
    var fileurls = [];
    let promiseArray = [];
    var attachments = [];
    const config = {
      headers: {
        "Content-Type": "application/octet-stream",
        "Access-Control-Allow-Origin": "*"
      }
    };

    if (noti_image_data.length > 0) {
      for (var i = 0; i < noti_image_data.length; i++) {
        if (!noti_image_data[i].uploaded) {
          promiseArray.push(
            axios.put(noti_image_data[i].url, noti_image_data[i].image, config)
          );
        }
        const image = {
          nodeid: noti_image_data[i].nodeid,
          fileid: noti_image_data[i].fileid,
          mimetype: noti_image_data[i].mime,
          bucketid: noti_image_data[i].bucketid,
          fileversion: noti_image_data[i].fileversion,
          title:
            noti_image_data[i].title ||
            noti_image_data[i].image?.name?.split(".")[0],
          description: noti_image_data[i].description || ""
        };
        attachments.push(image);
      }
    }

    if (noti_video_data.length > 0) {
      for (var i = 0; i < noti_video_data.length; i++) {
        if (!noti_video_data[i].uploaded) {
          promiseArray.push(
            axios.put(noti_video_data[i].url, noti_video_data[i].image, config)
          );
        }
        const image = {
          nodeid: noti_video_data[i].nodeid,
          fileid: noti_video_data[i].fileid,
          mimetype: noti_video_data[i].mime,
          bucketid: noti_video_data[i].bucketid,
          fileversion: noti_video_data[i].fileversion,
          title:
            noti_video_data[i].title ||
            noti_video_data[i].image?.name?.split(".")[0],
          description: noti_video_data[i].description || ""
        };
        attachments.push(image);
      }
    }
    if (noti_docs_data.length > 0) {
      for (var i = 0; i < noti_docs_data.length; i++) {
        if (!noti_docs_data[i].uploaded) {
          promiseArray.push(
            axios.put(noti_docs_data[i].url, noti_docs_data[i].image, config)
          );
        }
        const image = {
          nodeid: noti_docs_data[i].nodeid,
          fileid: noti_docs_data[i].fileid,
          mimetype: noti_docs_data[i].mime,
          bucketid: noti_docs_data[i].bucketid,
          fileversion: noti_docs_data[i].fileversion,
          title: noti_docs_data[i].title,
          description: noti_docs_data[i].description
        };
        attachments.push(image);
      }
    }

    const response = await axios.all(promiseArray).then(function(results) {
      var ok = results.map(r => r.data);
      return ok;
    });
    const created = Date.now();
    const usernodeid = JSON.parse(getItem("usernodeid"));
    const workflownodeid = location.state.workflownodeid;
    const workflowstepnodeid = location.state.workflowstepnodeid;

    const lang = "de";

    await persistAttachmentMetadataUpdates(persistedAttachmentUpdates, lang);

    if (location.state && location.state.from == "notification") {
      if (location.state && location.state.pageType == "edit") {
        const attachmentType = "Create";
        props.UpdateWorkFlowStep(
          {
            workflownodeid,
            title_workflow,
            workflowstepnodeid,
            description,
            attachmentType,
            attachments,
            lang
          },
          "UPDATEWORKFLOW"
        );
      } else {
        const notificationnodeid = location.state.notification.nodeid;
        props.CreateWorkFlowStep({
          created,
          usernodeid,
          notificationnodeid,
          description,
          attachments,
          lang,
          title_workflow
        });
      }
    } else if (location.state && location.state.from == "faq") {
      const lang = "de";
      if (location.state && location.state.pageType == "edit") {
        const attachmentType = "Create";
        const questionanswernodeid = location.state.questionanswernodeid;
        const question = title_workflow;
        const answer = description;
        props.UpdateFaq({
          questionanswernodeid,
          question,
          answer,
          attachmentType,
          attachments,
          lang
        });
      } else {
        const question = title_workflow;
        const answer = description;
        const usernodeid = JSON.parse(getItem("usernodeid"));
        const isfaqof = location.state.equipmentnodeid;
        const specifier = location.state.specifier;

        props.CreateFaq({
          lang,
          question,
          answer,
          usernodeid,
          isfaqof,
          specifier,
          attachments
        });
      }
    } else if (location.state && location.state.from == "faqMB") {
      const lang = "de";
      if (location.state && location.state.pageType == "edit") {
        const attachmentType = "Create";
        const questionanswernodeid = location.state.questionanswernodeid;
        const question = title_workflow;
        const answer = description;
        props.UpdateFaq({
          questionanswernodeid,
          question,
          answer,
          attachmentType,
          attachments,
          lang
        });
      } else {
        const question = title_workflow;
        const answer = description;
        const usernodeid = JSON.parse(getItem("usernodeid"));
        const isfaqof = location.state.equipmenttypenodeid;
        const specifier = location.state.specifier;

        props.CreateFaq({
          lang,
          question,
          answer,
          usernodeid,
          isfaqof,
          specifier,
          attachments
        });
      }
    }

    setnoti_loader(false);
    setNavigate(true);
  };

  /*
   * Styles
   */
  const useStyles = makeStyles()(theme => ({
    elevatedSection: {
      ...theme.elevatedSection
    },
    sectionHeader: {
      ...theme.sectionHeader
    },
    sectionDivider: {
      marginBottom: 28
    }
  }));
  const { classes } = useStyles(props, {
    props: props
  });

  const [noti_image_data, setnoti_image_data] = useState([]);
  const [noti_video_data, setnoti_video_data] = useState([]);
  const [noti_docs_data, setnoti_docs_data] = useState([]);
  const [persistedAttachmentUpdates, setPersistedAttachmentUpdates] = useState(
    []
  );

  const receiveChildValueAttachment = (
    images,
    videos,
    docs,
    from,
    persistedChanges
  ) => {
    setnoti_image_data(images);
    setnoti_video_data(videos);
    setnoti_docs_data(docs);
    setPersistedAttachmentUpdates(persistedChanges || []);
  };

  const [openDialogDelete, setopenDialogDelete] = useState();

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const handleDelete = () => {
    const nodeid = location.state.questionanswernodeid;
    props.DeleteFaq({ nodeid });
    setNavigate(true);
  };

  let titleError =
    title_workflow === "" ||
    title_workflow === undefined ||
    title_workflow === null;
  let descriptionError =
    description === "" || description === undefined || description === null;

  return (
    <>
      {!props.propLocation && (
        <Breadcrumbs
          aria-label="breadcrumb"
          className={_s(Theme247.breadcrumbs)}
        >
          <Link
            to={
              location.state && location.state.from == "notification"
                ? getNotificationDetailsPath()
                : location.state && location.state.from == "faqMB"
                ? "/equipmenttype-overview?nodeid=" +
                  encodeURIComponent(location.state.equipmenttypenodeid) +
                  "&tab=2"
                : "/machine-overview?nodeid=" +
                  encodeURIComponent(location.state.equipmentnodeid) +
                  "&tab=3"
            }
          >
            <ArrowBackIcon size="large" />
            {i18n.backLink}
          </Link>
        </Breadcrumbs>
      )}

      <section style={{ marginBottom: "20%" }}>
        <Paper
          elevation={!props.propLocation && Theme247.elevationLow}
          className={classes.elevatedSection}
          style={{
            padding: props.propLocation && 0,
            border: !props.propLocation && "none",
            boxShadow: !props.propLocation && "none !important"
          }}
        >
          {!props.propLocation && (
            <header className={classes.sectionHeader}>
              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space-between"
              >
                <Grid item>
                  {location.state && location.state.from == "notification" ? (
                    <Typography variant="h1">
                      {location.state != undefined
                        ? i18n.edit_solution
                        : i18n.add_solution}
                    </Typography>
                  ) : (
                    <Typography variant="h1">
                      {location.state != undefined
                        ? i18n.edit_faq
                        : i18n.add_faq}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </header>
          )}

          <form className={_s(Theme247.form)}>
            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={9}>
                      <TextField
                        className={_s(Theme247.inputField)}
                        onChange={e => {
                          settitle_workflow(e.target.value);
                        }}
                        error={titleError}
                        defaultValue={
                          location.state &&
                          location.state.from == "notification"
                            ? location.state && location.state.title
                            : location.state && location.state.question
                        }
                        label={
                          location.state &&
                          location.state.from == "notification"
                            ? "Titel"
                            : i18n.faq_question
                        }
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={9}>
                      <TextField
                        multiline
                        rows="5"
                        error={descriptionError}
                        onChange={e => {
                          setdescription(e.target.value);
                        }}
                        label="Antwort"
                        placeholder={
                          location.state &&
                          location.state.from == "notification"
                            ? location.state.workflow_step_desc
                            : i18n.faq_answer
                        }
                        className={classes.textarea}
                        variant="outlined"
                        defaultValue={
                          location.state &&
                          location.state.from == "notification"
                            ? location.state && location.state.description
                            : location.state && location.state.answer
                        }
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs={9}>
                        <br/>

                      <NotificationAttachments
                        from={location.state && location.state.from}
                        rootNodeId={location.state.equipmentnodeid}
                        edit={true}
                        specifier={
                          location.state &&
                          location.state.from == "notification"
                            ? "SolutionAttachment"
                            : "FaqAttachment"
                        }
                        nodeId={
                          location.state &&
                          location.state.from == "notification"
                            ? location.state &&
                              location.state.workflowstepnodeid
                            : location.state &&
                              location.state.questionanswernodeid
                        }
                        fromChildToParentCallback={receiveChildValueAttachment}
                        propLocation={location}
                      />
                        <br/>

                    </Grid>
                  </Grid>

                  <Grid container spacing={3} style={{ maxWidth: 475 }}>
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        disabled={titleError || descriptionError || noti_loader}
                        onClick={submitForm}
                        style={{ textTransform: "none" }}
                        startIcon={
                          noti_loader ? (
                            <CircularProgress size={15} color="info" />
                          ) : (
                            ""
                          )
                        }
                      >
                        {location.state && location.state.from == "notification"
                          ? i18n.save_solution
                          : i18n.save_FAQ}
                      </Button>
                    </Grid>
                    {location.state && location.state.pageType == "edit"
                      ? canUserPerformAction(
                          props.profile?.features?.["equipment.faq"],
                          "delete"
                        ) && (
                          <Grid item xs={6}>
                            <Button
                              variant="contained"
                              color="error"
                              size="large"
                              className={_s(Theme247.submitButton)}
                              onClick={() => {
                                setopenDialogDelete(true);
                              }}
                            >
                              {i18n.delete}
                            </Button>
                          </Grid>
                        )
                      : ""}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
          <DeletePopUp
            open={openDialogDelete}
            handleClose={handleDialogDelete}
            handleDelete={handleDelete}
            topic={"Maßnahme"}
          ></DeletePopUp>
        </Paper>
      </section>
    </>
  );
});
